import React from "react"

export interface RouteContextType  {
    isInitialized: boolean;
}
const RouteContext = React.createContext<RouteContextType>({ isInitialized: false});
export default RouteContext;
